import classes from '../../targetMarketPlan.module.scss';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useSalesPlan } from '../../useSalesPlan';
import { Dropdown } from 'primereact/dropdown';

const SalesPlanViewTable = () => {
  const {
    salesPlanningMonth,
    directSalesPlanCOT,
    isSalesDetailsLoading,
    salesPlanPeriod,
    salesplanPlanningPeriod,
    isSalesplanPlanningPeriodLoading,
    getValues,
    setDirectSalesPlanCOT,
    getSalesSummaryVal,
    handleOptionChange,
  } = useSalesPlan();

  return (
    <div>
      <div className={classes.planDetailsContainer}>
        <h4>
          <div>
            <span>Choose Plan:</span>
          </div>
          <div className={classes.planningPeriodDropdown}>
            <Dropdown
              disabled={salesplanPlanningPeriod.length === 0}
              value={salesPlanPeriod}
              options={salesplanPlanningPeriod}
              loading={isSalesplanPlanningPeriodLoading}
              optionLabel="label"
              onChange={e => {
                handleOptionChange(e.target.value);
              }}
              style={{ width: '15rem' }}
            />
          </div>
        </h4>
        {/* Direct Container start */}
        <div className={classes.directContainer}>
          <div>
            <p
              style={{
                fontSize: '20px',
                marginLeft: '1rem',
                fontWeight: '600',
                color: '#4D2E6D',
              }}
            >
              Direct
            </p>
            <div className={classes.saleDetails}>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingLeft: '3rem',
                  }}
                >
                  YTD:
                  <span>
                    {isSalesDetailsLoading ? (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    ) : (
                      getSalesSummaryVal(directSalesPlanCOT.value, 'YTD', 'direct')
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>
                  3MA:
                  <span>
                    {!isSalesDetailsLoading ? (
                      getSalesSummaryVal(directSalesPlanCOT.value, '3MA', 'direct')
                    ) : (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingRight: '3rem',
                  }}
                >
                  PM:
                  <span>
                    {!isSalesDetailsLoading ? (
                      getSalesSummaryVal(directSalesPlanCOT.value, 'PM', 'direct')
                    ) : (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className={classes.directRadioGrp}>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directSalesPlanCOT.label === 'CMOP'}
                  onClick={() => {
                    setDirectSalesPlanCOT(() => ({
                      label: 'CMOP',
                      value: 'cmop',
                    }));
                  }}
                />
                <label htmlFor="cmop">CMOP</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directSalesPlanCOT.label === 'VA Facility'}
                  onClick={() => {
                    setDirectSalesPlanCOT(() => ({
                      label: 'VA Facility',
                      value: 'va facility',
                    }));
                  }}
                />
                <label htmlFor="va">VA Facility</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directSalesPlanCOT.label === 'TMOP'}
                  onClick={() => {
                    setDirectSalesPlanCOT(() => ({
                      label: 'TMOP',
                      value: 'tmop',
                    }));
                  }}
                />
                <label htmlFor="tmop">TMOP</label>
              </span>
              <span>
                <input
                  type="radio"
                  name="directRadio"
                  checked={directSalesPlanCOT.label === 'MTF'}
                  onClick={() => {
                    setDirectSalesPlanCOT(() => ({
                      label: 'MTF',
                      value: 'mtf',
                    }));
                  }}
                />
                <label htmlFor="mtf">MTF</label>
              </span>
            </div>
          </div>
          <div>
            <div className={classes.planTable}>
              <table>
                <thead>
                  <th>
                    <td>Planning Period</td>
                  </th>
                  <th>
                    <td>Market Forecast</td>
                  </th>
                  <th>
                    <td>Adj Market Forecast</td>
                  </th>
                  <th>
                    <td>TMS</td>
                  </th>
                  <th>
                    <td>MS Plan</td>
                  </th>
                  <th>
                    <td>EU Sales Plan</td>
                  </th>
                </thead>
                <tbody>
                  {salesPlanningMonth.map((_, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{salesPlanningMonth[idx].label}</td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'direct',
                            'marketForecast'
                          )}
                        </td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'direct',
                            'adjforecast'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'direct',
                            'tmsvalue'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'direct',
                            'msplan'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'direct',
                            'euforecast'
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Direct Container end */}
        <hr />
        {/* Indirect Container start */}
        <div className={classes.directContainer}>
          <div>
            <p
              style={{
                fontSize: '20px',
                marginLeft: '1rem',
                fontWeight: '600',
                color: '#4D2E6D',
              }}
            >
              Indirect
            </p>
            <div className={classes.saleDetails}>
              <div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingLeft: '3rem',
                  }}
                >
                  YTD:
                  <span>
                    {!isSalesDetailsLoading ? (
                      getSalesSummaryVal(directSalesPlanCOT.value, 'YTD', 'indirect')
                    ) : (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div style={{ fontSize: '14px', fontWeight: '600' }}>
                  3MA:
                  <span>
                    {!isSalesDetailsLoading ? (
                      getSalesSummaryVal(directSalesPlanCOT.value, '3MA', 'indirect')
                    ) : (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    )}
                  </span>
                </div>
                <div className={classes.vertical}></div>
                <div
                  style={{
                    fontSize: '14px',
                    fontWeight: '600',
                    paddingRight: '3rem',
                  }}
                >
                  PM:
                  <span>
                    {!isSalesDetailsLoading ? (
                      getSalesSummaryVal(directSalesPlanCOT.value, 'PM', 'indirect')
                    ) : (
                      <ProgressSpinner
                        style={{
                          width: '10px',
                          height: '10px',
                          padding: 0,
                          margin: 0,
                        }}
                        strokeWidth="8"
                        fill="var(--surface-ground)"
                        animationDuration="1s"
                      />
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div>
            <div className={classes.planTable}>
              <table>
                <thead>
                  <th>
                    <td>Planning Period</td>
                  </th>
                  <th>
                    <td>Market Forecast</td>
                  </th>
                  <th>
                    <td>Adj Market Forecast</td>
                  </th>
                  <th>
                    <td>TMS</td>
                  </th>
                  <th>
                    <td>MS Plan</td>
                  </th>
                  <th>
                    <td>EU Sales Plan</td>
                  </th>
                </thead>
                <tbody>
                  {salesPlanningMonth.map((_, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{salesPlanningMonth[idx].label}</td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'indirect',
                            'marketForecast'
                          )}
                        </td>
                        <td style={{ color: '#7B4B9F', fontWeight: '600' }}>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'indirect',
                            'adjforecast'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'indirect',
                            'tmsvalue'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'indirect',
                            'msplan'
                          )}
                        </td>
                        <td>
                          {getValues(
                            directSalesPlanCOT.value,
                            salesPlanningMonth[idx].dateString,
                            'indirect',
                            'euforecast'
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Indirect Container end */}
      </div>
    </div>
  );
};

export default SalesPlanViewTable;
